/**
 * Property Panel Design System — design tokens.
 *
 * Shared visual primitives for panel-style UIs (PanelCard / PanelRow and
 * anything else that wants the same look). Import the `PANEL_TOKENS` object
 * and reference it from `sx` rather than hard-coding hex values, so the
 * palette stays consistent and tweakable in one place.
 */
export const PANEL_TOKENS = {
  color: {
    // Surfaces
    bgPage: "#f5f5f3",
    bgCard: "#ffffff",
    bgSubtle: "#f1efe8",

    // Text
    textPrimary: "#1a1a18",
    textSecondary: "#5f5e5a",
    textTertiary: "#888780",

    // Borders — 0.5px lines render as a true hairline on retina.
    borderDefault: "rgba(0, 0, 0, 0.08)",
    borderStrong: "rgba(0, 0, 0, 0.15)",

    // Semantic — danger (flood-cert warnings, errors)
    dangerBg: "#fcebeb",
    dangerBorder: "#f7c1c1",
    dangerText: "#791f1f",
    dangerTextStrong: "#501313",
    dangerSolid: "#a32d2d",

    // Semantic — info (calculated, locked)
    infoBg: "#e6f1fb",
    infoText: "#0c447c",

    // Semantic — success (completed states)
    successBg: "#eaf3de",
    successText: "#27500a",
  },

  // Type scale (px). Only two weights — 400 and 500.
  text: {
    xs: 11, // eyebrow labels, metadata
    sm: 12, // button text, badges
    base: 13, // body text, table rows
    md: 14, // card headers
    lg: 18, // primary metric values, page titles
  },
  weight: {
    regular: 400,
    medium: 500,
  },

  radius: {
    sm: "4px", // badges
    md: "8px", // metric cards, buttons, inputs
    lg: "12px", // container cards
    pill: "999px", // tag pills
  },

  // Component padding
  space: {
    cardPaddingX: "16px",
    cardPaddingY: "14px",
    rowPaddingY: "10px",
  },
};

export default PANEL_TOKENS;
